import { Controller } from "stimulus";
import { CountUp } from 'countup.js';

export default class extends Controller {
  static targets = ['value']

  connect() {
    const url = this.element.getAttribute('data-stats-url');
    const dateStart = this.element.getAttribute('data-stats-date-start');
    const dateEnd = this.element.getAttribute('data-stats-date-end');
    
    const params = encodeURI([`start_date=${dateStart}`, `end_date=${dateEnd}`].join('&'));
    Rails.ajax({
      url: `${url}?${params}`,
      type: 'GET',
      success: (data) => {
        this.valueTargets.forEach((target) => {
          const type = target.getAttribute('data-event-type');
          const countUp = new CountUp(target, data[type]);
          if (!countUp.error) {
            countUp.start();
          } else {
            console.error(countUp.error);
          }
        })
      }
    })
  }
  
}